<template>
  <div class="login">
    <div class="loginWrapper">
      <div class="mx-auto max-w-md w-full loginScreen" :class="{ submitting: submitting == true }">
        <form v-if="!forgotPassword" @submit.prevent="emailSubmit">
          <img src="@/assets/neou-logo.png" class="neouLogo" />
          <h1 class="signIn">
            If you would like to use a personal email address, you can update it here:
          </h1>
          <md-field :class="getValidationClass('email')">
            <label for="email">Email Address (optional)</label>
            <md-input name="email" id="email" autocomplete="email" v-model="form.email"/>
            <span class="md-error" v-if="!$v.form.email.required">Email is required</span>
            <span class="md-error" v-else-if="!$v.form.email.email">Invalid email</span>
          </md-field>
           <md-field :class="getValidationClass('confirmEmail')">
            <label for="confirmEmail">Confirm Email Address</label>
            <md-input name="confirmEmail" id="email" autocomplete="email" v-model="form.confirmEmail"/>
            <span class="md-error" v-if="!$v.form.email.sameAsEmail">Emails must match</span>
          </md-field>
          <md-button class="md-raised neouButton" type="submit">
            <md-progress-spinner md-mode="indeterminate" :md-diameter="20" :md-stroke="2"></md-progress-spinner>Continue
          </md-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  MdField,
  MdButton,
  MdProgress,
  MdIcon
} from "vue-material/dist/components";
import { validationMixin } from "vuelidate";
import { required, email, sameAs } from "vuelidate/lib/validators";
import "@/assets/tweaked-vue-material.min.css";
import axios from "axios";
import cryptLib from "@skavinvarnan/cryptlib";
import * as firebase from "firebase";
import { parse } from "query-string";

Vue.use(MdField);
Vue.use(MdIcon);
Vue.use(MdButton);
Vue.use(MdProgress);

export default {
  name: "CapitalOneSetEmail",
  mixins: [validationMixin],
  data: () => ({
    form: {
      email: null,
      confirmEmail: null
    },
    emailPassed: false,
    isUserExist: false,
    isValidEmail: false,
    submitting: false,
    isSocialLogin: false,
    isAppleLogin: false,
    isVLUser: false,
    forgotPassword:false,
    passwordResetSent: false,
    hideSocial: false,
    isCof: false,
    id: "",
    params: {}
  }),
  validations: {
    form: {
      email: {
        required,
        email
      },
      confirmEmail: {
        sameAsEmail: sameAs("email")
      }
    }
  },
  mounted: function() {
  },
  beforeMount: function() {
  },
  methods: {
    getValidationClass: function(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
    emailSubmit() {
      console.log( 'hi' );
      this.submitting = true;
      this.$v.form.email.$touch();
      this.$v.form.confirmEmail.$touch();
      if (!this.$v.form.email.$invalid) {
        axios
          .post(
            "https://api.neoufitness.com/neou/v1/user/verifyEmail",
            {
              email: this.form.email
            },
            {
              headers: {
                Authorization: "JWT " + this.$cookie.get("token")
              }
            }
          ).then(res => {
            if( !res.data.isUserExist && res.data.isValidEmail ){
              axios
              .post(
                "https://api.neoufitness.com/neou/v1/user/update-email",
                {
                  newEmail: this.form.email,
                  oldEmail: this.$attrs.email
                },
                {
                  headers: {
                    Authorization: "JWT " + this.$cookie.get("token"),
                    token: this.$cookie.get("getUserToken")
                  }
                }
              ).then(res => {
                window.dataLayer.push({
                  event: "cap_one_email_set",
                });
                this.$emit("nextScreen");
              })
            }
          });
        //   .then(res => {
        //     if(res.data.isCapitalOneUser){
        //       window.open("https://api.neoufitness.com/neou/v1/sso/callback", "_self");
        //       return;
        //     }
        //     if (res.data.isAppleLogin) {
        //       this.$emit(
        //         "warningMessage",
        //         'You logged in with Apple Sign-In before. Please click "Sign in with Apple"'
        //       );
        //       this.submitting = false;
        //     } else if (res.data.isSocialLogin) {
        //       this.$emit(
        //         "warningMessage",
        //         'You logged in with Facebook before. Please click "Continue with Facebook"'
        //       );
        //       this.submitting = false;
        //     } else {
        //       this.isUserExist = res.data.isUserExist;
        //       this.isValidEmail = res.data.isValidEmail;
        //       this.isVLUser = res.data.isVLUser;
        //       this.emailPassed = true;
        //       this.passwordSubmit();
        //     }
        //   })
        //   .catch(err => {
        //     console.log(err.message);
        //     this.submitting = false;
        //   });
        this.$emit("nextScreen");
      } else {
         window.dataLayer.push({
          event: "cap_one_email_skip",
        });
        this.submitting = false;
        this.$emit("nextScreen");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.forgotPasswordContainer{
  width:100%;
  text-align:center;
  margin-top:20px;
}
.forgotSuccessHeader{
    font-family: "prox", Helvetica;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  text-align: center;
  margin-top:50px;
}
.forgot{
font-size: 11px;
  line-height: 14px;
  text-align: right;
  margin: 0px 0px 10px 0px;
  display:block;
  color: #505B63;
  text-decoration:underline;
  cursor:pointer;


  a{
    color:#56fffe;
    cursor:pointer;
  }
}
.submitting {
  .neouButton {
    color: transparent;
  }
  .md-progress-spinner {
    display: inline-flex;
  }
}
.md-progress-spinner {
  stroke: black;
  position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 10px);
  display: none;
}
.login {
  position: relative;
  max-width: 400px;
  padding: 0px 15px;
  margin: 0px auto;
  width: 100%;
  color:#12161A;
}
.loginWrapper {
  display: flex;
  justify-content: center;
}
.loginScreen {
  width: 280px;
  padding: 40px 0px;
  position: relative;
  z-index: 2;
}
.neouLogo {
  width: 140px;
  margin: 0px auto;
  display: block;
  filter:invert(1);
}
.welcomeBack {
  text-align: center;
  font-style: italic;
  font-size: 40px;
}
.featureList {
  list-style: none;
  margin: 0px;
  padding: 0px;
}
.feature {
  margin: 5px 0px;
}
.checkmark {
  margin: 0px 10px 0px 0px;
}
.regularText {
  text-align: center;
}
.signIn {
  font-family: "prox", Helvetica;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  text-align: center;
  margin: 40px 0px 20px 0px;
}
.md-field:after {
  border-bottom: 1px solid #35414a;
}
.md-field label {
  color: #8b949b;
  font-style: italic;
}
.md-field .md-input {
  color: #12161A;
}
.termsLink {
  font-size: 11px;
  line-height: 14px;
  text-align: center;
  margin: 18px 0px;
  color: rgb(140, 148, 155);

  a {
    color: rgb(140, 148, 155);
    text-decoration:underline;
  }
}
.md-toggle-password {
  color: #35414a;
}
.orLine {
  overflow: hidden;
  padding: 0px;
  text-align: center;
  color: #35414a;
  line-height: 40px;
  width: 100%;
  &:before,
  &:after {
    background-color: #35414a;
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: 40%;
    color: #35414a;
  }
  &:before {
    right: 0.5em;
    margin-left: -25%;
  }
  &:after {
    left: 0.5em;
    margin-right: -25%;
  }
  span {
    font-size: 12px;
    line-height: 40px;
    text-align: center;
    padding: 20px;
    color: #8c949b;
    font-weight: bold;
  }
}
.iconApple {
  position: absolute;
  left: -35px;
  top: 50%;
  transform: translateY(-50%);
}

.iconFacebook{
  position: absolute;
  left: -35px;
  top: 50%;
  transform: translateY(-50%);
}
</style>
